export default "__VITE_ASSET__WFnEtgfG__"